import { useEffect, useState, type ReactNode } from 'react';
import { CurrentUserProvider, PermissionsProvider, type CurrentUser } from '@jywer/ui';

interface MeResponse {
  userId?: string;
  email?: string;
  permissions?: readonly string[];
}

interface BootState {
  user: CurrentUser;
  permissions: readonly string[];
}

export function PermissionsBoot({ children }: { children: ReactNode }) {
  const [state, setState] = useState<BootState | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/me')
      .then((r) => {
        if (!r.ok) throw new Error(`/api/me → HTTP ${r.status}`);
        return r.json() as Promise<MeResponse>;
      })
      .then((d) => {
        if (!d.userId || !d.email) {
          throw new Error('/api/me missing userId/email');
        }
        setState({
          user: { userId: d.userId, email: d.email },
          permissions: d.permissions ?? [],
        });
      })
      .catch((e) => setErr(e instanceof Error ? e.message : 'auth error'));
  }, []);

  if (err) {
    return (
      <div className="p-6 text-sm text-status-err">
        Kunne ikke hente brugerens rettigheder: {err}
      </div>
    );
  }
  if (state === null) {
    return <div className="p-6 text-sm text-ink-2">Henter rettigheder…</div>;
  }
  return (
    <CurrentUserProvider user={state.user}>
      <PermissionsProvider permissions={state.permissions}>{children}</PermissionsProvider>
    </CurrentUserProvider>
  );
}
